/**
 * Release 4 switch for AI suggestions in Brand Setup (spec:113-125; lane W6). On: an empty field of a
 * wizard step is offered an AI suggestion (features/brand-setup/suggestions), and Fill in manually says
 * so (spec:88). Off: no field offers a suggestion and no sentence promises one, as in Release 3. Like
 * every Brand Setup feature it shows only where the install's Brand Workspace v2 flag is on. One file per
 * Release 4 lane, so each lane flips only its own.
 */
export const SUGGESTIONS_ENABLED: boolean = true;
